var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaperPlaneLightTopRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.146 27c.756 0 1.293-.65 1.68-1.659l6.878-17.968c.188-.482.296-.913.296-1.27C27 5.42 26.58 5 25.894 5c-.356 0-.786.105-1.27.294l-18.061 6.92C5.683 12.55 5 13.086 5 13.853c0 .966.733 1.291 1.74 1.596l8.193 1.618 1.596 8.095c.316 1.061.642 1.838 1.617 1.838zm-2.743-11.529L7.55 13.863c-.168-.052-.221-.094-.221-.168 0-.073.043-.126.201-.189L21.728 8.13c.84-.315 1.646-.735 2.426-1.093-.696.567-1.556 1.24-2.134 1.817zm2.91 9.219c-.083 0-.124-.073-.177-.241l-1.607-7.854 6.617-6.617c.564-.567 1.27-1.45 1.824-2.163-.356.797-.786 1.606-1.102 2.457l-5.376 14.197c-.06.158-.104.22-.178.22z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlaneLightTopRight);
export default __webpack_public_path__ + "static/media/Paper-Plane-Light_TopRight.a9d220df985f8caf4998336bd71f5cb5.svg";
export { ForwardRef as ReactComponent };